import { Reveal, Overline } from "../Reveal";
import { ASSETS } from "../assets";

export default function Slide02Positioning() {
  return (
    <section className="slide bg-[var(--ais-cream)]" data-testid="slide-02">
      <div className="grid grid-cols-1 md:grid-cols-12 min-h-screen">
        <div className="md:col-span-7 flex items-center px-6 md:px-16 lg:px-24 py-24">
          <div className="max-w-xl">
            <Reveal>
              <Overline>02 — Positioning</Overline>
            </Reveal>
            <Reveal delay={1}>
              <div className="hairline w-16 my-8" />
            </Reveal>
            <Reveal delay={2}>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.75rem] text-[var(--ais-espresso)] leading-[1.08] tracking-[-0.01em] font-light">
                A new Italian voice
                <br />
                in <em className="italic">luxury</em> world.
              </h2>
            </Reveal>
            <Reveal delay={3}>
              <p className="mt-10 font-sans text-[var(--ais-text)] text-base md:text-lg leading-[1.85] font-light">
                AIS is a young Italian maison built on the codes of a heritage
                house: fully handcrafted footwear, selected top-quality leathers
                and a refined attention to comfort. A brand free of legacy
                constraints — and free to be shaped, together with the right
                partner, around the market it is dedicated to.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="md:col-span-5 relative min-h-[55vh] md:min-h-screen overflow-hidden bg-[var(--ais-cream-2)] flex items-center justify-center">
          <img
            src={ASSETS.brownSabotSunset}
            alt="AIS — brown fringed sabot at sunset villa"
            className="w-full h-full object-cover kenburns"
            style={{ objectPosition: "center 55%" }}
          />
        </div>
      </div>
    </section>
  );
}
